import { render, staticRenderFns } from "./DashboardMealPendingOrders.vue?vue&type=template&id=be8255be&scoped=true"
import script from "./DashboardMealPendingOrders.vue?vue&type=script&lang=js"
export * from "./DashboardMealPendingOrders.vue?vue&type=script&lang=js"
import style0 from "./DashboardMealPendingOrders.vue?vue&type=style&index=0&id=be8255be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be8255be",
  null
  
)

export default component.exports